import { IClientSocket } from "./IClientSocket";

export abstract class AbstractClientSocketManager {
    abstract create(channels: string[]): IClientSocket;

    abstract forceReconnect(): void;
    abstract forceDisconnect(): void;
}
